export const provinceAdminiterativeLevel = "administrative_area_level_1";
export const storageItemProvince = "province";